// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"926":"7b3b9171","3243":"c3a71a48"}[chunkId] + ".chunk.css";
};